export { panelStyle }

import { errorStyle, hintStyle, neutralStyle, successStyle } from '../../components/messageStyles.ts'
import { buttonStyle, inputStyle } from '../../components/formStyles.ts'

// LicenseKeysPanel + EmailPanel mirror vike.dev's /free <FreeTrialForm> (the public free-trial form):
// the field + quiet family-B submit (the shared `formStyles`, matching /free's submit) sit on one row
// (flex), and the note copies vike.dev's docpress blockquote — so the dashboard's license form matches
// the marketing-site form 1:1. Page-level chrome stays inline in +Page.tsx.
const panelStyle = {
  panel: { marginTop: 32, paddingTop: 24, borderTop: '1px solid #e5e5e5' },
  h2: { margin: '0 0 12px', fontSize: 18 },
  hint: hintStyle,
  // An instruction/label introducing a block (e.g. the snippet) — darker than `hint`.
  caption: { fontSize: 13, margin: '0 0 4px' },
  // Copy of vike.dev/free's docpress-blockquote note: rgba tint + 8px left rule, no radius.
  note: {
    margin: '12px 0',
    padding: '0 16px',
    paddingTop: 10,
    paddingBottom: 16,
    background: 'rgba(0, 0, 0, 0.043)',
    borderLeft: '8px solid rgba(0, 0, 0, 0.09)',
    color: '#323d48',
    fontSize: 16,
    lineHeight: 1.5,
  },
  // Field + button on one row (vike.dev/free layout); the field grows, the button is auto-width,
  // wrapping below on a narrow panel.
  form: { display: 'flex', alignItems: 'flex-end', gap: 12, flexWrap: 'wrap' as const, marginTop: 12 },
  field: { flex: '1 1 280px', minWidth: 0 },
  label: { fontSize: 13, marginBottom: 4 },
  // Field + family-B submit (formStyles), matching /free. <Login> uses the bolder primaryButtonStyle.
  input: inputStyle,
  button: buttonStyle,
  success: successStyle,
  error: errorStyle,
  // Gray box for a no-op submit ("no new domains added — already in your license").
  neutral: neutralStyle,
}
